import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";



function FacturasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_SERIES_FISCAL = import.meta.env.VITE_URL_SERIES_FISCAL;
  const URL_TIMBRAR = import.meta.env.VITE_URL_TIMBRAR;
  const URL_FACTURAS = import.meta.env.VITE_URL_FACTURAS;
  const URL_ARTICULOS_SURTIDOS = import.meta.env.VITE_URL_ARTICULOS_SURTIDOS;
  const URL_SURTIDOS = import.meta.env.VITE_URL_SURTIDOS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_EMPRESAS = import.meta.env.VITE_URL_EMPRESAS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  
  const [timbresDisponibles, setTimbresDisponibles] = useState(0);

  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalCant, setTotalCant] = useState(0);

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");

  const [condicionesPagoSATCliente, setCondicionesPagoSATCliente] = useState("")
  const [formaPagoSATCliente, setFormaPagoSATCliente] = useState("")
  const [metodoPagoSATCliente, setMetodoPagoSATCliente] = useState("")
  const [rfcCliente, setRfcCliente] = useState("")
  const [nombreCliente, setNombreCliente] = useState("")
  const [usoCFDICliente, setUsoCFDICliente] = useState("")
  const [regFiscalCliente, setRegFiscalCliente] = useState("")
  const [cpCliente, setCpCliente] = useState("")

  const [serie, setSerie] = useState("")

  
  const [inputFields, setInputFields] = useState([]);

  const [surtidosData, setSurtidosData] = useState([]);
  const ordenTallas = ["EXTRA CHICA", "XCH", "CHICA", "CH", "M", "MEDIANA", "GRANDE", "G", "EXTRA GRANDE", "XG"];

  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_SERIES_FISCAL}Timbres`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allTimbres = res.data;
          setTimbresDisponibles(allTimbres[0].folio);
        })
        .catch((err) => {
          console.log(err);
        });
     
      axios
      .get(`${URL_EMPRESAS}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allEmpresas = res.data;
          setEmpresas(allEmpresas);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_COLABORADORES}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allColaboradores = res.data;
            setColaboradores(allColaboradores);
          })
          .catch((err) => {
            console.log(err);
          });
  }, []);

  // --- Mensajes de error claros al facturar / timbrar -------------------------
  // El SAT (vía Facturama) rechaza por datos concretos del receptor. Antes se
  // mostraba "Something went wrong!" y el usuario reintentaba en vano.
  const textoErrorFacturama = (resp) => {
    const o = Array.isArray(resp) ? resp[resp.length - 1] : resp;
    if (!o) return "";
    if (typeof o === "string") return o;
    if (o.ModelState) return Object.values(o.ModelState).flat().join(" ");
    return o.Message || o.message || o.error || "";
  };

  const detalleError = (error) => {
    const d = error?.response?.data;
    if (!d) return error?.message || String(error);
    if (typeof d === "string") return d;
    if (Array.isArray(d.errores) && d.errores.length) return d.errores.join(" ");
    if (d.ModelState) return Object.values(d.ModelState).flat().join(" ");
    return (
      d.message ||
      d.Message ||
      d.error ||
      textoErrorFacturama(d.respuestaFacturama) ||
      error?.message ||
      JSON.stringify(d)
    );
  };

  const esErrorDeDatos = (texto = "") =>
    /rfc|r[ée]gimen|uso ?cfdi|uso de cfdi|forma de pago|c[óo]digo postal|nombre del receptor|receptor|dato[s]? fiscal/i.test(
      texto
    );

  const swalErrorFactura = (error, titulo = "No se pudo timbrar la factura") => {
    const detalle = detalleError(error);
    Swal.fire({
      icon: "error",
      title: titulo,
      html:
        `<div style="text-align:left">${detalle}</div>` +
        (esErrorDeDatos(detalle)
          ? `<br/><div style="text-align:left"><b>Reintentar no va a funcionar.</b> Corrija estos datos del cliente (Catálogo de Clientes / Constancia de Situación Fiscal) y vuelva a facturar.</div>`
          : ""),
    });
    console.log(error);
  };

  const saveFacturaNuevo = async (event) => {
    event.preventDefault();

    // Candado de doble clic: se toma INMEDIATAMENTE. Antes se tomaba hasta
    // después de los pre-checks asíncronos, y dos clics con milisegundos de
    // diferencia entraban los dos (así se duplicaron CFDIs en el SAT). Todo
    // camino que no termina en recarga de página debe liberarlo.
    if (submittingRef.current) return;
    submittingRef.current = true;

    // --- PRE-CHECK: datos fiscales del cliente completos ---
    // Estos campos son obligatorios para un CFDI válido; si el cliente se dio
    // de alta como "por definir" pueden venir vacíos. Avisamos el campo exacto
    // en lugar de dejar que el backend/PAC devuelva un error genérico.
    if (selectedCliente) {
      const camposFiscales = [
        { valor: regFiscalCliente, label: "Régimen Fiscal" },
        { valor: usoCFDICliente, label: "Uso de CFDI" },
        { valor: formaPagoSATCliente, label: "Forma de Pago Fiscal" },
        { valor: metodoPagoSATCliente, label: "Método de Pago Fiscal" },
      ];
      const faltantes = camposFiscales
        .filter((c) => c.valor === undefined || c.valor === null || String(c.valor).trim() === "")
        .map((c) => c.label);
      if (faltantes.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Faltan datos fiscales del cliente",
          html:
            `No se puede facturar: al cliente le falta capturar:<br/><br/>` +
            `<b>${faltantes.join("<br/>")}</b><br/><br/>` +
            `Complétalos en <b>Catálogos → Clientes</b> (editar cliente) y vuelve a intentar.`,
        });
        submittingRef.current = false;
        return;
      }

      // El SAT rechaza PUE con forma de pago 99 ("Por definir"): avisamos antes de
      // consumir folio, porque después ningún reintento lo resuelve.
      if (metodoPagoSATCliente === "PUE" && formaPagoSATCliente === "99") {
        Swal.fire({
          icon: "warning",
          title: "Forma de pago inválida",
          html:
            `Con <b>Método de Pago PUE</b> el SAT no acepta la Forma de Pago <b>99 (Por definir)</b>.<br/><br/>` +
            `Seleccione la forma real (01 Efectivo, 03 Transferencia, 04 Tarjeta...) o corrija el cliente en <b>Catálogos → Clientes</b>.`,
        });
        submittingRef.current = false;
        return;
      }
    }

    // --- PRE-CHECK: detectar factura existente antes de crear una nueva ---
    let existingFacturaId = "";
    // Cuando se facturan varios surtidos a la vez hay que decir CUÁL es el que ya
    // tiene factura; si no, parece que el bloqueo es del surtido que se quiere facturar.
    let ticketConFactura = "";

    for (const field of inputFields) {
      if (!field.surtidos) continue;
      try {
        const res = await axios.get(`${URL_SURTIDOS}/${field.surtidos}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        const s = res.data;
        if (s.facturado === "Si") {
          const fId = Array.isArray(s.facturas)
            ? (s.facturas[0]?._id || s.facturas[0])
            : (s.facturas?._id || s.facturas);
          if (fId) {
            existingFacturaId = String(fId);
            ticketConFactura = field.idSurtido || String(s.idSurtido || "");
            break;
          }
        }
      } catch (e) {
        console.warn("Pre-check factura existente:", e);
      }
    }

    if (existingFacturaId) {
      // Mostrar POR QUÉ falló el intento anterior; si fue por datos fiscales,
      // reintentar es inútil hasta corregir el cliente.
      let motivoPrevio = "";
      try {
        const resFac = await axios.get(`${URL_FACTURAS}/${existingFacturaId}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        motivoPrevio = textoErrorFacturama(resFac.data?.respuestaFacturama);
      } catch (e) {
        console.warn("No se pudo leer el motivo del fallo previo:", e);
      }
      const bloqueoPorDatos = motivoPrevio && esErrorDeDatos(motivoPrevio);

      const confirm = await Swal.fire({
        title: "Factura existente detectada",
        html:
          (ticketConFactura
            ? `El surtido <b>${ticketConFactura}</b> ya tiene una factura registrada en el sistema.`
            : "Este surtido ya tiene una factura registrada en el sistema.") +
          (motivoPrevio
            ? `<br/><br/><div style="text-align:left"><b>El intento anterior falló por:</b><br/>${motivoPrevio}</div>`
            : "") +
          (bloqueoPorDatos
            ? `<br/><div style="text-align:left;color:#d33"><b>Reintentar no va a funcionar</b> hasta corregir ese dato en el Catálogo de Clientes (Constancia de Situación Fiscal).</div>`
            : "") +
          "<br/><br/>¿Deseas <b>reintentar solo el timbrado</b> sin crear una nueva factura?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: bloqueoPorDatos ? "Reintentar de todos modos" : "Reintentar Timbrado",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) {
        submittingRef.current = false;
        return;
      }

      setValidaBoton(false);
      toggleProgreso();
      try {
        await axios.post(
          `${URL_TIMBRAR}Factura`,
          { facturas: existingFacturaId },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        await axios.post(
          URL_LOGS,
          { tipo: "Reintentar Timbrado", detalle: `Reintento timbrado factura ${existingFacturaId}`, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Timbrado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      } catch (error) {
        // 409 = el backend detectó que la factura YA estaba timbrada (candado anti-duplicado).
        // No es un error: se evitó un CFDI duplicado. Avisamos y recargamos.
        if (error?.response?.status === 409) {
          await Swal.fire({
            icon: "info",
            title: "Ya estaba timbrada",
            text: "Esta factura ya había sido timbrada previamente. No se generó un duplicado.",
          });
          window.location.reload();
          return;
        }
        swalErrorFactura(error);
        submittingRef.current = false;
        setValidaBoton(true);
        setModalProgreso(false);
      }
      return;
    }
    // --- FIN PRE-CHECK ---

    if(timbresDisponibles > 0){
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará la Factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then(async (result) => {
    // El candado ya se tomó al entrar a saveFacturaNuevo; si el usuario
    // cancela hay que liberarlo o el botón queda bloqueado.
    if (!result.isConfirmed) {
      submittingRef.current = false;
      return;
    }
    if (
      subTotal > 0 &&
      total > 0
    ) {
      setValidaBoton(false);
      toggleProgreso();

      let totalArticulos =
        inputFields.length
      try {
        await axios
          .post(
            URL_FACTURAS,
            {
              fecha,
              observaciones,
              totalCantidad:totalCant,
              subTotal: parseFloat((subTotal).toFixed(2)),
              iva: parseFloat((iva).toFixed(2)),
              total: parseFloat((total).toFixed(2)),
              abonos:0,
              saldo: parseFloat((total).toFixed(2)),
              pagado:"No",
              descuentoPorcentaje1:0,
              descuentoNumero1:0,
              descuentoConcepto1:"NA",
              descuentoPorcentaje2:0,
              descuentoNumero2:0,
              descuentoConcepto2:"NA",
              empresas: selectedEmpresa,
              clientes: selectedCliente,
              colaboradores: selectedColaborador,
              timbre:"No",
              currency: "MXN",
              cfdiType:"I",
              
              serie,
              expeditionPlace: cpEmpresa,

              rfcEmpresa,
              nombreEmpresa,
              regFiscalEmpresa,

              condicionesPagoSATCliente,
              formaPagoSATCliente,
              metodoPagoSATCliente,
              rfcCliente,
              nombreCliente,
              usoCFDICliente,
              regFiscalCliente: String(regFiscalCliente),
              cpCliente: String(cpCliente),

              numeroPagos:0,

            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {

            inputFields.map((w) => {
              axios
                .patch(
                  `${URL_SURTIDOS}Factura/${w.surtidos}`,
                  {
                    facturas: data.data._id,
                    facturado: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {

                    axios.post(`${URL_TIMBRAR}Factura`,{
                      facturas: data.data._id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    ).then(()=>{

                      axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Factura",
                          detalle: `Fecha Factura ${fecha} ${data.data.idFactura}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        swalErrorFactura(error);
                        submittingRef.current = false;
                        setValidaBoton(true);
                        setModalProgreso(false)
                      });

                    }).catch((error) => {
                      swalErrorFactura(error);
                      submittingRef.current = false;
                      setValidaBoton(true);
                      setModalProgreso(false)
                    });
                  }
                })
                .catch((error) => {
                  swalErrorFactura(error);
                  submittingRef.current = false;
                  setValidaBoton(true);
                  setModalProgreso(false)
                });
            });


          })
          // Catch primer then
          .catch((error) => {
            swalErrorFactura(error);
            submittingRef.current = false;
            setValidaBoton(true);
            setModalProgreso(false)
          });
      } catch (error) {
        swalErrorFactura(error);
        submittingRef.current = false;
        setValidaBoton(true);
        setModalProgreso(false)
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Faltan datos",
        text: "La factura no tiene subtotal o total mayor a cero. Revise los surtidos seleccionados.",
      });
      submittingRef.current = false;
      setValidaBoton(true);
      setModalProgreso(false)
    }
  })
}else{
  Swal.fire({
    icon: "error",
    title: "Sin timbres disponibles",
    text: "No hay timbres disponibles para facturar. Contacte a administración.",
  });
  submittingRef.current = false;
  setValidaBoton(true);
  setModalProgreso(false)
}
  };

  
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let din = values.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    let subTotalSinIva = TD / 1.16;
    let ivaAmount = TD - subTotalSinIva;
    setSubTotal(subTotalSinIva);
    setIva(ivaAmount);
    setTotal(TD);
  };


  function BuscaCliente(event) {
    setSelectedCliente(event.target.value)
    setSurtidosData([])

    setInputFields(
      [{
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      }]
      );

    clientes.map((a)=>{
      if(a._id == event.target.value){
      setCondicionesPagoSATCliente(a.condicionesPagoSAT)
      setRfcCliente(a.RFC)
      setNombreCliente(a.razon_social)
      setUsoCFDICliente(a.usoCFDI)
      setRegFiscalCliente(a.regFiscal)
      setCpCliente(a.cp)
      setSelectedColaborador(a.vendedor[0]._id)

      if(a.metodoPagoSAT != "PPD"){
      // Con PUE el SAT rechaza la forma de pago 99 ("Por definir"); si el catálogo del
      // cliente la trae así, se deja vacía para que se elija la real antes de facturar.
      setFormaPagoSATCliente(a.formaPagoSAT === "99" ? "" : a.formaPagoSAT)
      setMetodoPagoSATCliente(a.metodoPagoSAT)
      }else{
        setFormaPagoSATCliente("99")
        setMetodoPagoSATCliente(a.metodoPagoSAT)
      }

      if(event.target.value != ""){
        axios
        .get(`${URL_SURTIDOS}Facturacion/${event.target.value}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allSurtidos = res.data;
            let arrayTabla = allSurtidos.map((a)=>{
              return {
                id: uuidv4(),
                surtidos: a._id,
                idSurtido: a.idSurtido,
                total: a.subTotal,
                totalCantidad: a.total_cantidad,
              }
            })
            let dataFinal = Object.values(arrayTabla);
            setSurtidos(dataFinal);
          })
          .catch((err) => {
            console.log(err);
          });
      }

    }
    })



  }


  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value)

    empresas.map((a)=>{
      if(a._id == event.target.value){
        setCpEmpresa(a.cp)
        setRfcEmpresa(a.rfc)
        setNombreEmpresa(a.razonSocial)
        setRegFiscalEmpresa(a.regimenFiscal)
      }
    })
    setInputFields(
    [{
      id: uuidv4(),
      surtidos: "",
      idSurtido: "",
      total: 0,
      totalCantidad: 0,
    }]
    );
    if(event.target.value != "" && selectedCliente != ""){
      axios
      .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSurtidos = res.data;
          let arrayTabla = allSurtidos.map((a)=>{
            return {
              id: uuidv4(),
              surtidos: a._id,
              idSurtido: a.idSurtido,
              total: a.subTotal,
              totalCantidad: a.total_cantidad,
            }
          })
          let dataFinal = Object.values(arrayTabla);
          setSurtidos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }


  async function BuscaSurtido(id, event) {
    setSurtidosData([])
  
    if (inputFields.some((e) => e.surtidos === event.target.value)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido ya fue capturado!",
        showConfirmButton: false,
      });
  
      setInputFields(inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i)));
      return;
    }
  
    try {
      surtidos.map((a) => {
         if (a.surtidos == event.target.value) {
           let surtidos = a.surtidos;
           let idSurtido = a.idSurtido;
           let total = a.total
           let totalCantidad = a.totalCantidad
           handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad);
         }
       });
       
      const response = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${event.target.value}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
  
      if (!response.data.length) {
        console.warn("La API no devolvió datos");
        return;
      }
  
      let allArticulosSurtido = response.data;
      let colorTallaCantidad = {};
  
      allArticulosSurtido.forEach((a) => {
        const color = a.colores[0].name;
        const talla = a.tallas[0].name;
        const cantidad = a.cantidad;
  
        if (!colorTallaCantidad[talla]) {
          colorTallaCantidad[talla] = {};
        }
        if (!colorTallaCantidad[talla][color]) {
          colorTallaCantidad[talla][color] = 0;
        }
        colorTallaCantidad[talla][color] += cantidad;
      });
  
      const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
  
      const colores = [...new Set(allArticulosSurtido.map((a) => a.colores[0].name))].sort();
  
      setSurtidosData(
        tallas.map((talla) => {
          // Buscar el primer artículo con esta talla
          const articulo = allArticulosSurtido.find(
            (a) => a.tallas[0]?.name === talla
          );
      
          return {
            talla,
            nombreArticulo: articulo?.articulos?.[0]?.nombre || 'Desconocido',
            precio: articulo?.articulosPedido?.[0]?.precio || 0,
            colores: colores.map((color) => ({
              color,
              cantidad: colorTallaCantidad[talla]?.[color] || 0,
            })),
          };
        })
      );
      
  
  
  
    } catch (err) {
      console.error("Error en la petición a la API:", err);
    }
  }
  

  const handleChangeInputArticulo = (id, surtidos, idSurtido, total, totalCantidad) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.surtidos = surtidos;
        i.idSurtido = idSurtido;
        i.total = total;
        i.totalCantidad = totalCantidad
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };


  function ActualizaTotales(fields) {
    const source = fields || inputFields;

    let din = source.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);

    let tcan = source.map((c) => parseFloat(c.totalCantidad));
    let TDCan = tcan.reduce((t, total, index) => t + total, 0);
    setTotalCant(TDCan);

    let subTotalSinIva = TD / 1.16;
    let ivaAmount = TD - subTotalSinIva;
    setSubTotal(subTotalSinIva);
    setIva(ivaAmount);
    setTotal(TD);
  }





 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturasFiscal ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Factura</h3>
          <Form onSubmit={saveFacturaNuevo}>
            <Row>
            <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label>Fecha Factura</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                    <Input
                      name="empresa"
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(event) => {
                        BuscaEmpresa(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        if(a.listoFacturar == "Si" && a.is_active == "Si"){
                          return (
                            <option value={a._id}>{a.name}</option>
                          );}
                      })}
                    </Input>
                  </Col>

                  <Col md={2}>
                <Label>Cliente</Label>
                    <Input
                      type="select"
                      value={selectedCliente}
                      required
                      onChange={(event) => {
                        BuscaCliente(event);
                      }}
                    >
                      <option value="">Selecciona un Cliente</option>
                      {clientes
                        .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.razon_social} / {a.nombre_comercial}</option>
                          );
                      })}
                    </Input>
                  </Col>

                  {/* Vista de solo lectura de lo que se va a enviar al SAT como receptor.
                      rfcCliente/nombreCliente se congelan en la factura al guardar, así que
                      un typo del catálogo de Clientes hay que verlo AQUÍ antes de guardar,
                      no hasta que Facturama lo rechace. No es editable: para corregirlo hay
                      que arreglar el Catálogo de Clientes y volver a seleccionar el cliente. */}
                  {nombreCliente && (
                    <Col md={3}>
                      <Label>Se facturará a (según catálogo)</Label>
                      <Input type="text" value={nombreCliente} disabled title="Nombre/Razón Social que se enviará al SAT" />
                      <Input type="text" value={rfcCliente} disabled className="mt-1" title="RFC que se enviará al SAT" />
                    </Col>
                  )}

                  {/* <Col md={2}>
                <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      required
                      onChange={(event) => {
                        BuscaColaborador(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre} {a.apellido} </option>
                          );
                      })}
                    </Input>
                  </Col> */}

                  <Col md={2}>
                <Label>Serie</Label>
                    <Input
                      type="select"
                      value={serie}
                      required
                      onChange={(event) => {
                        setSerie(event.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="A">A</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSATCliente}
                  required
                  onChange={(e) => {
                    setFormaPagoSATCliente(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>
                  </Row>
             <Row>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>


            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Nota</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="surtidos"
                      type="select"
                      value={inputField.surtidos}
                      required
                      onChange={(event) => {
                        BuscaSurtido(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {surtidos
                      .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a.surtidos}>
                            Surt: {a.idSurtido}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>

                <Col md={1} className="d-flex align-items-center">
                  <h6>
                    {new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(inputField.total)}
                  </h6>
                </Col>
                  {/* <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ))}

            {/* Tabla Articulos */}
            {surtidosData.length > 0 && (
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Articulo</th>
              <th>Talla</th>
              {surtidosData[0].colores.map((c, index) => (
                <th key={index}>{c.color}</th>
              ))}
              <th>Total Piezas</th>
              <th>Precio</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {surtidosData.map((surtido, index) => {
              const totalFila = surtido.colores.reduce((sum, c) => sum + c.cantidad, 0);
              return (
                <tr key={index}>
                  <td>{surtido.nombreArticulo}</td>
                  <td>{surtido.talla}</td>
                  {surtido.colores.map((c, i) => (
                    <td key={i}>{c.cantidad}</td>
                  ))}
                  <td><strong>{totalFila}</strong></td>
                  <td>{new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(surtido.precio)}</td>
                  <td><strong>{new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(totalFila * surtido.precio)}</strong></td>
                </tr>
              );
            })}

            {/* Fila de totales por columna */}
            <tr>
              <td><strong>Total</strong></td>
              {surtidosData[0].colores.map((_, i) => {
                const totalColumna = surtidosData.reduce((sum, surtido) => sum + surtido.colores[i].cantidad, 0);
                return <td key={i}><strong>{totalColumna}</strong></td>;
              })}
              <td><strong>{surtidosData.reduce((sum, surtido) => sum + surtido.colores.reduce((s, c) => s + c.cantidad, 0), 0)}</strong></td> {/* Total general */}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}


       
            <br />
            <br />
            <Row>
            <Col>
            <Label className="mr-sm-2">Subtotal</Label>
            <Input
              type="number"
              value={subTotal}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">IVA</Label>
            <Input
              type="number"
              value={iva}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">Total</Label>
            <Input
              type="number"
              value={total}
              disabled
            />
            </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoFacturas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default FacturasCreate;
